import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { FieldProp } from "../model/FieldProp";
import { DateTimeModel } from "../../../businessFoundation/Primitives/DateTimeManage/DateTimeModel";
import { TextField } from "@episerver/ui-framework";

const DateTimeField: React.FC<FieldProp<any>> = (props) => {
    const { index, property, control, errors, setValue } = props;
    const validationData = property.validationData as DateTimeModel;

    useEffect(() => {
        if (property.value) {
            setValue(`extendedProperties[${index}].value`, property.value.slice(0, 16));
        } else {
            setValue(`extendedProperties[${index}].value`, "");
        }
    }, [property.value]);

    const checkValue = (str: string | null) => {
        if (str) {
            const minValue = parseFloat(validationData.minValue.replace(/-/g, ""));
            const maxValue = parseFloat(validationData.maxValue.replace(/-/g, ""));
            const value = parseFloat(str.replace(/-/g, ""));
            const timeValue = str.replace(/-/g, "").slice(9);
            if (value < minValue) {
                return `${property.friendlyName} must not be before ${validationData.minValue}.`;
            } else if (value > maxValue) {
                return `${property.friendlyName} must not be after ${validationData.maxValue}.`;
            } else if (value === maxValue && timeValue > "00:00") {
                return `${property.friendlyName} was out of the range of valid values [${validationData.minValue} 00:00:00, ${validationData.maxValue} 00:00:00]`;
            } else {
                return "";
            }
        } else if (property.isNullable) {
            return "";
        } else {
            return `${property.friendlyName} is invalid`;
        }
    };

    return (
        <Controller
            name={`extendedProperties[${index}].value`}
            control={control}
            rules={{
                required: {
                    value: !property.isNullable,
                    message: `${property.friendlyName} is required`,
                },
                validate: {
                    [`properties[${index}].value`]: (v) => {
                        const result = checkValue(v);
                        if (result) {
                            return result;
                        } else {
                            return true;
                        }
                    },
                },
            }}
            render={({ field: { value, onChange } }) => (
                <TextField
                    id={`extendedProperties[${index}].value`}
                    type="datetime-local"
                    outlined
                    label={property.friendlyName}
                    helperText={
                        errors.extendedProperties
                            ? errors.extendedProperties[index]?.value?.message ?? property.description
                            : property.description
                    }
                    invalid={errors.extendedProperties && errors.extendedProperties[index]?.value ? true : false}
                    value={value}
                    onChange={onChange}
                />
            )}
        />
    );
};

export default DateTimeField;
